/**
 * HUB-G — Carte événement timeline unifiée (DS Remobiles).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowRightLeft } from 'lucide-react';
import MagasinBadge from '../MagasinBadge';
import { formatEventDate } from '../../utils/activite/activityEvents';

function formatAmount(event) {
  if (event.amount == null || event.amount === '') return null;
  if (event.type === 'stock') return `Qté ${event.amount}`;
  return `${Number(event.amount).toFixed(2)} €`;
}

export default function ActiviteTimelineCard({ event, testIdPrefix = 'activite-timeline' }) {
  const amountLabel = formatAmount(event);

  return (
    <article
      className="rounded-xl border p-4"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-event-${event.id}`}
    >
      <div className="flex flex-wrap items-start justify-between gap-2 mb-2">
        <div className="min-w-0 flex-1">
          <Link
            to={event.deepLink}
            className="font-semibold text-[var(--rm-white)] hover:text-[var(--rm-red-light)] text-sm inline-flex items-center gap-1"
            data-testid={`${testIdPrefix}-link-${event.id}`}
          >
            <span className="truncate">{event.label}</span>
            <ArrowRight className="w-3 h-3 shrink-0" />
          </Link>
          {event.detail && (
            <p className="text-xs text-[var(--rm-gray-500)] mt-0.5 truncate">{event.detail}</p>
          )}
        </div>
        <span className={event.badge}>{event.typeLabel}</span>
      </div>

      <div className="flex flex-wrap items-center gap-2 mb-2">
        {event.magasin_id_to ? (
          <span className="inline-flex items-center gap-1.5 text-xs">
            <MagasinBadge code={event.magasin_id || 'M1'} size="sm" />
            <ArrowRightLeft className="w-3 h-3 text-[var(--rm-gray-500)]" />
            <MagasinBadge code={event.magasin_id_to} size="sm" />
          </span>
        ) : (
          <MagasinBadge code={event.magasin_id || 'M1'} size="sm" />
        )}
        {event.status && (
          <span className="text-xs text-[var(--rm-gray-500)]">{event.status}</span>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm">
        <div>
          <span className="text-[var(--rm-gray-500)]">Date </span>
          <span className="text-[var(--rm-gray-300)]">{formatEventDate(event.at)}</span>
        </div>
        <div>
          <span className="text-[var(--rm-gray-500)]">Par </span>
          <span className="text-[var(--rm-gray-300)]">{event.user || '—'}</span>
        </div>
        {amountLabel && (
          <div>
            <span className="text-[var(--rm-gray-500)]">Montant </span>
            <span className="font-bold text-[var(--rm-white)]">{amountLabel}</span>
          </div>
        )}
      </div>
    </article>
  );
}
